import { useState } from 'react';
import { useNavigate } from 'react-router';
import { useTranslation } from 'react-i18next';
import { Plus } from 'lucide-react';
import { Button } from '~/components/ui/buttons/Button';
import { useGetOrganizationsPaginated } from '~/api/organizations';
import { useDebouncedSearchInput } from '~/hooks/useDebouncedSearchInput';
import OrganizationsTableCard from '~/components/common/OrganizationsTableCard';
import CreateOrganizationModal from './sections/CreateOrganizationModal';

export default function AdminOrganizations() {
  const navigate = useNavigate();
  const { t } = useTranslation('organizations');

  const { searchInputValue, activeSearch, handleSearchChange } =
    useDebouncedSearchInput();
  const [createModalOpen, setCreateModalOpen] = useState(false);

  const {
    data: allOrganizations,
    sentinelRef,
    isLoading,
    pagination,
  } = useGetOrganizationsPaginated(20, activeSearch);

  return (
    <>
      <CreateOrganizationModal
        open={createModalOpen}
        onClose={() => setCreateModalOpen(false)}
      />

      <div className="w-full flex flex-col gap-6">
        {/* Page header */}
        <div className="flex items-start justify-between gap-4">
          <div>
            <h1 className="text-xl font-semibold text-neut-prim">
              {t('organizations.title')}
            </h1>
            <p className="text-sm text-neut-sec mt-1">
              {t('organizations.subtitle')}
            </p>
          </div>
          <Button
            size="sm"
            width="auto"
            onClick={() => setCreateModalOpen(true)}
          >
            <Plus size={16} className="mr-1" />
            {t('organizations.createButton')}
          </Button>
        </div>

        <OrganizationsTableCard
          organizations={allOrganizations}
          tableName="organizations"
          isLoading={isLoading}
          totalElements={pagination?.totalElements ?? 0}
          sentinelRef={sentinelRef}
          searchInputValue={searchInputValue}
          onSearchChange={handleSearchChange}
          onOpenOrganization={(organization) =>
            navigate(`/admin/organizations/${organization.id}`, {
              state: { organization },
            })
          }
        />
      </div>
    </>
  );
}
